// extracted by mini-css-extract-plugin
export default {"navigation":"navigation_navigation__+637Z","navigationItem":"navigation_navigationItem__lpmLK"};